import React from 'react';
import { formatDateRange } from './helper';

const EventDetails = ({ event }) => {
  if (!event) {
    return (
      <div className="h-full flex items-center justify-center text-gray-500">
        Select an event to view details
      </div>
    );
  }

  const dateRange = formatDateRange(event.conference_start_date, event.conference_end_date);

  return (
    <div className="py-6 lg:pl-14 justify-center grid grid-cols-1 items-center justify-items-center lg:items-start lg:justify-items-start">
      <h4 className="text-h4_medium text-dark_green mb-4 text-center lg:text-left">{event.event_name}</h4>
      
      {/* Location Details */}
      <div className="space-y-4 mb-6">
        <p className="text-paragraph mb-4 text-center lg:text-left">{dateRange} | {event.conference_city}, {event.conference_state} </p>
      </div>

      {/* Action Buttons */}
      <div className="space-y-3">
        {event.registration_url && (
          <button
            onClick={() => window.open(event.registration_url, '_blank')}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full inline-flex items-center px-[32px] py-[24px] text-dark_green font-bold rounded-all_48 border-gradient-button hover:border-gradient-button-hover transition-all duration-300"
          >
            Visit Conference Website
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none" style={{ marginLeft: '16px' }}>
              <path d="M1.65674 1.19989L7.31359 6.85674L1.65674 12.5136" stroke="#7AC593" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default EventDetails; 